import { Grid } from '@mui/material';
import React, { useContext } from 'react';
import { AuthDataProvider } from 'src/components/authProvider';
import { ScreenConfiguration } from 'src/components/screenConfiguration';
import { WarningBox } from 'src/components/warningBox/warningBox';
import { SelectDropdownWidget } from 'src/components/widget';
import { InfoBox } from 'src/features/components/editComponentPage/modules/InfoBox';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { lang } from 'src/utils';

import { LocationTimingHeaderProps } from './LocationTimingsHeader.interface';
import {
  AlertContainer,
  BoxContainer,
  Container,
  Divider,
  SubHeader,
  SubHeaderText,
} from './LocationTimingsHeader.styled';

export const LocationTimingsHeader = (props: LocationTimingHeaderProps) => {
  const { userRole } = useContext(AuthDataProvider);

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Grid container rowSpacing={2} columnSpacing={6}>
            <Grid item xs={10}>
              <SelectDropdownWidget
                canCopy={true}
                menuItemWidth={726}
                onChange={props.updateSelectedLocationGroup}
                value={props.selectedLocationGroup?.id}
                label={lang.selectChannel}
                selectOptions={props.channelsData.map((locationGroup) => ({
                  label: locationGroup.channel_name,
                  value: locationGroup.id,
                }))}
                options={{
                  placeholder: lang.selectChannel,
                }}
              />
            </Grid>
            <Grid item>
              <SubHeader>{lang.screenConfiguration}</SubHeader>
              {props.selectedLocationGroup?.channel_name && (
                <ScreenConfiguration
                  channelName={props.selectedLocationGroup?.channel_name}
                  scale={0.03}
                />
              )}
            </Grid>
            {userRole !== AuthClassification.OWNER_OPERATOR && (
              <Grid item>
                <SubHeader>{lang.locationGroup}</SubHeader>
                {props.isDefaultLocationGroup ? (
                  <WarningBox>{lang.assignToLocationGroup}</WarningBox>
                ) : (
                  <SubHeaderText>
                    {props.selectedLocationGroup?.name}
                  </SubHeaderText>
                )}
              </Grid>
            )}
            <Grid item>
              <SubHeader>{lang.channelType}</SubHeader>
              <SubHeaderText>
                {props.selectedLocationGroup?.layoutType?.name}
              </SubHeaderText>
            </Grid>
          </Grid>
        </Grid>
        {userRole !== AuthClassification.OWNER_OPERATOR ? (
          <Grid item xs={12} md={5}>
            <BoxContainer>
              <AlertContainer>
                <InfoBox visible>
                  {props.scheduleDaypartsAvailable
                    ? props.isDefaultLocationGroup || props.rbStoreIntegration
                      ? lang.alertMessages.defaultDaypartsTiming
                      : lang.alertMessages.toggleDaypart
                    : props.isDefaultLocationGroup && props.rbStoreIntegration
                    ? lang.alertMessages.defaultDaypartsTiming
                    : props.rbStoreIntegration
                    ? lang.alertMessages.defaultDaypartsTiming
                    : lang.alertMessages.viewEditDayparts}
                </InfoBox>
              </AlertContainer>
            </BoxContainer>
          </Grid>
        ) : (
          <>
            {!props.scheduleDaypartsAvailable ||
              (props.rbStoreIntegration && (
                <Grid item xs={12} md={5}>
                  <BoxContainer>
                    <AlertContainer>
                      <InfoBox visible>
                        {props.rbStoreIntegration
                          ? lang.alertMessages.defaultDaypartsTiming
                          : lang.alertMessages.OOeditSchedules}
                      </InfoBox>
                    </AlertContainer>
                  </BoxContainer>
                </Grid>
              ))}
          </>
        )}
      </Grid>
      <Divider />
    </Container>
  );
};
